import { Component, Input } from '@angular/core';

export interface Cookie {
  name: string;
  description: string;
  duration: string;
  thirdParties?: string;
}

@Component({
  selector: 'cookie-table',
  templateUrl: './cookie-table.component.html',
  styleUrls: ['./cookie-table.component.scss']
})
export class CookieTableComponent {

  @Input() cookies: Cookie[];

  constructor(
  ) {
  }
}
